module.exports = __webpack_public_path__ + "img/platform-engine-32.18cfd465.svg";